import './about.css';
import AboutImg1 from '../../assets/image/about1img.jpg';
import AboutImg2 from '../../assets/image/about2img.png';
import AboutImg3 from '../../assets/image/about3img.jpg';
import { Box, Grid, Paper, Typography } from '@mui/material';
import Header from './Header';
import Footer from "../resuableComponents/Footer";

const About = () => {
	const values = [
		{
			title: 'Understanding',
			description:
				'We genuinely supervise assisting you in developing an incredible and extensively successful website for your company at an insufficient cost to you.',
		},
		{
			title: 'Professionalism',
			description:
				'We are extremely accountable for our work. Our professional experts abide by the rules and regulations, in proclamation to generate responsible reactions.',
		},
		{
			title: 'Capability',
			description:
				'We are experienced, skilled digital professionals, who constantly take care of the clients.',
		},
		{
			title: 'Transmission',
			description:
				'We keep available lines of communication with you throughout the fundamental process to make sure everything turns out as you retain.',
		},
		{
			title: 'Participation',
			description:
				'We collaborate with you to initiate the remarkable website that you have desired.',
		},
	];
	return (
		<>
			<Header />
			<section >
				<div className='about-container'>
					<div className='about-row'>
						{/* Image Section */}
						<div className='about-one-half'>
							<div className='aboutimg'>
								<img src={AboutImg1} alt='Best Web Design Company' />
							</div>
						</div>

						{/* Text Section */}
						<div className='about-one-half abouttext'>
							<div className='one-full top-heaidng big-text text-left'>
								<h2 style={{ fontSize: '3.1vw' }}>
									Our <strong>story</strong>
								</h2>
							</div>
							<p style={{ paddingLeft: '15px' }}>
								Welcome to Reseller Bano, one of India's top companies for UI/UX
								design, digital marketing, mobile app development, and web
								design & development. We aspire to be innovative, sustaining and
								a performing brand with appreciable and consistent competence in
								web design and development, mobile app development, UI/UX design
								and digital marketing. Reseller Bano is committed to continuous
								innovation and research in IT Infrastructure, path-breaking
								software development & UI/UX design, predictive analytics as
								well as new age digital market development. We are resolute in
								ensuring delivery of pristine solutions to businesses in
								Australia and all around the world.
							</p>
							<p className='highlighttext' style={{ paddingLeft: '15px' }}>
								Our promise of service is to provide you with a top-quality,
								future-proof website with all the superb services, features,
								functionality, and more that your business needs.
							</p>
						</div>
					</div>
				</div>
			</section>

			<section>
				<div className='about-container'>
					<div className='about-row'>
						<div className='about-one-half top-heaidng  text-left abouttext'>
							<div className='specialheading'>
								<h3
									style={{
										fontSize: '3.1vw',
										lineHeight: '35px',
										fontWeight: 'Bold',
									}}>
									At Reseller Bano
								</h3>
								<h2 style={{ fontSize: '3vw' }}>
									What you imagine
									<br />
									We innovate it
								</h2>
							</div>
							<p>
								Reseller Bano puts together a bunch of passionate minds to
								transform your visions into reality imparting an awesome digital
								experience for your users. From website design, development,
								scalable mobile apps to SaaS platforms, the solution we engineer
								accelerate efficiency and fuel growth for our clients. From
								2006, we are committed to achieving and pushing the level of
								performance at all times. Leveraging the power of technology, we
								deliver end-to-end solutions for multi-million dollar funded
								start-ups to small and medium enterprises. Art and culture
								inspire us too, and our office presence at New York and Kolkata
								is a true reflection.
							</p>
						</div>
						<div className='about-one-half'>
							<img
								className='fu8lwidthimg'
								src={AboutImg2}
								alt='digital marketing company in kolkata'
							/>
						</div>
					</div>
				</div>
			</section>

			<section style={{ backgroundColor: '#f2f2f2' }}>
				<div className='about-container'>
					<Box
						sx={{
							py: 6,
							px: 3,
							textAlign: 'center',
						}}>
						<Typography
							variant='h4'
							component='h2'
							sx={{ color: '#74b816', fontWeight: 'bold', mb: 4 }}>
							Our <span style={{ fontWeight: 700 }}>five core values</span>
						</Typography>
						<Grid container spacing={3} justifyContent='center'>
							{values.map((value, index) => (
								<Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
									<Paper
										elevation={3}
										sx={{
											p: 3,
											borderRadius: '12px',
											textAlign: 'center',
											height: '100%',
											transition: 'transform 0.3s ease, box-shadow 0.3s ease',
											'&:hover': {
												transform: 'scale(1.05)',
												boxShadow: '0 6px 20px rgba(0, 0, 0, 0.15)',
											},
										}}>
										<Box
											sx={{
												backgroundColor: '#74b816',
												borderRadius: '16px',
												px: 2,
												py: 0.5,
												display: 'inline-block',
												mb: 2,
												transition: 'background-color 0.3s ease',
												'&:hover': {
													backgroundColor: '#5c9e13',
												},
											}}>
											<Typography
												variant='h6'
												sx={{ color: '#fff', fontWeight: 'bold' }}>
												{value.title}
											</Typography>
										</Box>
										<Typography
											variant='body1'
											sx={{
												color: '#000',
												lineHeight: 1.6,
												fontSize: '0.95rem',
											}}>
											{value.description}
										</Typography>
									</Paper>
								</Grid>
							))}
						</Grid>
					</Box>
				</div>
			</section>

			<section>
				<div className='about-container'>
					<div className='about-row'>
						{/* Image Section */}
						<div className='about-one-half'>
							<div className='aboutimg'>
								<img src={AboutImg3} alt='Best Web Design Company' />
							</div>
						</div>

						{/* Text Section */}
						<div className='about-one-half abouttext'>
							<div className='one-full top-heaidng big-text text-left'>
								<h2 style={{ fontSize: '3.1vw' }}>
									Team and <br />
									<strong>leadership</strong>
								</h2>
							</div>
							<p style={{ paddingLeft: '15px' }}>
								Collectively, it's been several years of experience in working
								with the web and interactive applications. As people, we retain
								distinctive and complementary strategies towards things. At
								Reseller Ban, we joine together in the pace of excellence to
								share our accomplishments about the web-world with client's and
								outshine their anticipation upon us.
							</p>
							<p style={{ paddingLeft: '15px' }}>
								Our crew works incredibly hard, all through the day to deliver
								perfect outcomes in the assigned duration. Our obsession with
								some people is that the budget they possess is limited and this
								rationally becomes a barrier. Instead, we offer first-place
								services at an extremely reasonable cost.
							</p>
						</div>
					</div>
				</div>
			</section>

			<section className='pb-100'>
				<div className='about-container'>
					<div className='about-row'>
						<div className='about-one-half abouttext'>
							<div className='one-full top-heaidng big-text text-left'>
								<h2 style={{ fontSize: '3.1vw' }}>
									Our{' '}
									<strong>
										<br />
										work culture
									</strong>
								</h2>
								<p>
									We at Kre8iveminds are like a family, we care and support each
									other, which enables us to do our work with love and passion.
									Being a team of young and enthusiastic people, we work
									professionally to deliver a quality work keeping in mind given
									stipulated time. Every project we do is not just work of life
									to us, but it's our collective lives work. We do more than
									just work but we live our work. We allow our
									colleagues/employees to recreate themselves by playing music,
									games, and yoga etc.
									<br />
									<br /> Due to our friendly nature and work environment, our
									local clients love to visit our office, whose co-ordination
									helps us to give an un-cut edge to the projects. We are very
									transparent and open with our client, we share all ups and
									downs with our client during research & development of a
									particular project.
									<br />
									<br /> Client satisfaction is paramount to us. We always put
									our dedication and passion to get the job done within the
									given parameters, which brings a smile to our client's face.
								</p>
							</div>
						</div>
						<div className='about-one-half'>
							<div className='aboutimg'>
								<img
									src='https://www.kre8iveminds.com/assets/images/workculture.jpg'
									alt='seo services in kolkata'
								/>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer/>
		</>
	);
};

export default About;
